export const TierColConfigData = [
  {
    name_of_db_column: 'storeId',
    label_of_column: 'STORE ID',
    order_of_column: 1,
    columnFilterPlaceholder: 'STORE ID',
    hideSortIcon: 'true'
  },
  {
    name_of_db_column: 'displayDate',
    label_of_column: 'LAST UPDATED',
    order_of_column: 2,
    filterVariant: 'date',
    columnFilterPlaceholder: 'LAST UPDATED',
    hideSortIcon: 'true'
  }
];
